import { PMS } from '../constants';
import { MARKETING_CHANNEL_ID } from '../theme/theme.constants';

const getPMSByMarketChannelId = (marketingChanneldId) => {
  let pms = '';

  switch (marketingChanneldId) {
    case MARKETING_CHANNEL_ID.akc:
    case MARKETING_CHANNEL_ID.ppi:
    case MARKETING_CHANNEL_ID.ppiG:
    case MARKETING_CHANNEL_ID.ppu:
    case MARKETING_CHANNEL_ID.spot:
      pms = PMS.orca;
      break;

    case MARKETING_CHANNEL_ID.figo:
      pms = PMS.diamond;
      break;

    default:
      break;
  }

  return pms;
};

export {
  getPMSByMarketChannelId,
};
